export { default } from './SkeletonLine.js';
